import { Box, withStyles } from '@material-ui/core';
import { centerBoxProps } from 'globals/utils';
import FsBody from 'ui-elements/typography/FsBody';
import FsCenterBox from 'ui-elements/common-elements/FsCenterBox';

export const BackdropBox = withStyles(() => ({
  root: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 11,
  },
}))(Box);

export const WrapperBox = withStyles(({ spacing, breakpoints }) => ({
  root: {
    position: 'fixed',
    top: spacing(2),
    bottom: spacing(2),
    right: spacing(2),
    left: spacing(2),
    zIndex: 11,
    [breakpoints.up('sm')]: {
      top: spacing(3),
      bottom: spacing(3),
      right: spacing(3),
      left: 'auto',
      width: '100%',
      maxWidth: 435,
    },
  },
}))(Box);

export const AbsoluteBox = withStyles(({ spacing, breakpoints }) => ({
  root: {
    position: 'absolute',
    top: 160,
    bottom: spacing(2),
    left: spacing(3),
    right: spacing(1),
    [breakpoints.up('sm')]: {
      top: 140,
    },
  },
}))(Box);

export const SwitchesWrapperBox = withStyles(({ spacing }) => ({
  root: {
    ...centerBoxProps,
    justifyContent: 'flex-start',
    overflowX: 'auto',
    paddingBottom: spacing(1),
  },
}))(Box);

export const SingleSwitchBox = withStyles(({ spacing }) => ({
  root: {
    marginRight: spacing(1.5),
  },
}))(FsCenterBox);

export const Label = withStyles(({ spacing }) => ({
  root: {
    marginRight: spacing(0.5),
  },
}))(FsBody);
